import store from '@/store/store'

export default function retailerCompanyActivityControl(to, from, next) {
  if (store.getters['retailerAuth/token']) {
    store.dispatch('retailerAuth/getUser').then(user => {
      if (user.retailer.address.neighborhood_id) {
        next({ name: 'retailer.dashboard' })
      } else {
        next()
      }
    })
  } else {
    next()
    return
  }
}
